export default __webpack_public_path__ + "87ca06d.png";